import { useCallback, useEffect, useRef } from "react";
import { useTelegramAuth } from "./useTelegramAuth";

export function usePremiumModal() {
  const { user, authError } = useTelegramAuth();
  const botUsername =
    import.meta.env.VITE_TELEGRAM_BOT_USERNAME || "lotinuz_bot";
  const preloadRef = useRef(false);

  // Preload Telegram widget script globally on component mount
  // This ensures the script is cached and ready when modal opens
  useEffect(() => {
    if (typeof window === "undefined" || preloadRef.current) return;

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    document.body.appendChild(script);
    preloadRef.current = true;
  }, []);

  // Callback ref to load widget when element is mounted
  const telegramWidgetRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (node && !user) {
        // Clear previous widget
        node.innerHTML = "";

        const script = document.createElement("script");
        script.src = "https://telegram.org/js/telegram-widget.js?22";
        script.setAttribute("data-telegram-login", botUsername);
        script.setAttribute("data-size", "large");
        script.setAttribute("data-onauth", "onTelegramAuth(user)");
        script.setAttribute("data-request-access", "write");
        script.async = true;
        node.appendChild(script);
      }
    },
    [botUsername, user]
  );

  return {
    user,
    telegramWidgetRef,
    authError,
  };
}
